<div class="card border-reset">
  <div class="card-header card-padding text-center">
    <h3><b>{{deleteTitle}}</b></h3>
    <h4 class="c-neutral margin-t-s">{{deleteMessage}}</h4>
  </div>
  <div class="card-body">
    <div class="row margin-t">
      <div class="columns small-6 small-centered">
        <div class="button-group expanded">
          <a class="button rounded success" [mat-dialog-close]="true">{{'confirm' | translate}}</a>
          <a class=" button rounded alert" [mat-dialog-close]="false">{{'cancel' | translate}}</a>
        </div>
      </div>
    </div>
  </div>
</div>
